import React, { useRef } from "react";
import DatamapsIndia from "react-datamaps-india";
import { Card } from "react-bootstrap";
import { GraphCardsHeader } from "@ui";

function IndiaMap({
  stateData,
  title,
  valueSuffix = "",
  showStateLegend = true,
  needDownload = true,
  hideUnderline = false,
  titleCenter = false,
}) {
  const mapRef = useRef();

  const formatMapData = (mapData = {}) => {
    let output = {};
    if (Object.keys(mapData).length < 36) {
      output = {
        _forLowestValue: {
          value: 0,
        },
      };
    }
    for (const [key, value] of Object.entries(mapData)) {
      if (value && value === 0) continue;
      const formattedKey = key.replace(/_/g, " ");
      output[formattedKey] = {
        value: value || 0,
      };
    }
    return output;
  };

  function downloadDataAsCSV(data, filename = "state_data.csv") {
    const headers = "State,Value (%)\n";
    const rows = Object.entries(data)
      .map(([state, value]) => `"${state}","${value}%"`)
      .join("\n");
    const csvContent = headers + rows;
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  function downloadCSVHandler() {
    downloadDataAsCSV(stateData[0]);
  }

  return (
    <Card
      className="d-flex flex-column flex-grow-1 mb-0"
      data-aos="fade-up"
      data-aos-delay="500"
    >
      <GraphCardsHeader
        title={title}
        titleCenter={titleCenter}
        hideUnderline={hideUnderline}
        showDownloadButtons={true}
        needCSVDownload={needDownload}
        downloadCSV={downloadCSVHandler}
      />

      <Card.Body className="flex-grow-1 text-center india-map position-relative india-map-dashboard">
        {stateData?.length > 0 && (
          <div ref={mapRef}>
            <div>
              <DatamapsIndia
                regionData={formatMapData(stateData[0])}
                hoverComponent={({ value }) => {
                  return (
                    <div>
                      {value.name}: {value.value ?? 0}
                      {valueSuffix}
                    </div>
                  );
                }}
                mapLayout={{
                  startColor: "#e2e2fc",
                  endColor: "#005ce6",
                  hoverTitle: "Total",
                  noDataColor: "#fff",
                  borderColor: "#15607A",
                  hoverColor: "#15946C",
                  hoverBorderColor: "gray",
                  height: 10,
                  weight: 30,
                }}
              />
            </div>
            {showStateLegend && (
              <div className="legend-container d-flex flex-wrap justify-content-start px-3 mt-2 pb-3">
                {Object.entries(stateData[0])
                  ?.filter(([state, value]) => value !== 0)
                  ?.sort(
                    ([stateA, valueA], [stateB, valueB]) => valueB - valueA
                  )
                  ?.map(([state, value], index) => (
                    <div
                      key={index}
                      className="legend-item d-flex align-items-center mx-2 mb-1 fs-7"
                      style={{ color: "#333" }}
                    >
                      <span
                        className="legend-icon rounded-circle mr-2"
                        style={{
                          backgroundColor: "#3B3EAC",
                          width: "6px",
                          height: "6px",
                          display: "inline-block",
                          marginRight: "6px",
                        }}
                      ></span>

                      <span className="legend-label">
                        {`${state} (${value}${valueSuffix})`}
                      </span>
                    </div>
                  ))}
              </div>
            )}
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

export default IndiaMap;
